export const REGEX = {
  is_latin_characters_only:
    /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
  is_number: /^([\d ]+(?:[.,]\d{1,2})?)$/,
  starts_with_zero: /^0[0-9].*$/,
  is_local_host: /(localhost)/,
  is_valid_email:
    /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(dsv)\.com$/gi,
};
